import { useCallback, useContext } from 'react';
import moment from 'moment';
import _find from 'lodash/find';
import { AjaxContext, formatListData, AppContext, UserContext } from 'commons-ui';
import { GAME_NAMES, GAME_NAME_OPTIONS } from 'pages/constants';
import { UserDetailsContext } from 'context/userDetails';
import _number from 'lodash/toNumber';
import { ACTION, PAGE_NAMES, USER_PROFILE_RESOURCES } from 'constant';
import { ITournamentDetails } from '../types';

const GAMEPLAY_THRESHOLD_SECONDS: number = 480;
const getNxEndTime = (time: number) => {
	return moment(time).add(GAMEPLAY_THRESHOLD_SECONDS, 'seconds').valueOf();
};

const formatData = (
	data: { score: string; zupeeuserid: string }[],
	commonParams: {
		ltid: number | null | undefined;
		playingtableid: string | null | undefined;
		gamename: string | null | undefined;
	},
	currentUserId: number
): any => {
	const updateData = data.map((record: { score: string; zupeeuserid: string }) => {
		return { score: _number(record.score), zupeeUserId: _number(record.zupeeuserid) };
	});
	updateData.sort((a, b) => b.score - a.score);
	let rank = 0;
	const formattedData = [];
	for (let i = 0; i < updateData.length; i += 1) {
		const currRecord = updateData[i];
		rank += 1;
		if (i > 1) {
			const PrevRecord = updateData[i - 1];
			if (PrevRecord.score === currRecord.score) {
				rank -= 1;
			}
		}

		if (currRecord.zupeeUserId !== currentUserId) {
			formattedData.push({ ...currRecord, rank, ...commonParams });
		}
	}
	return formattedData;
};

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const { app } = useContext(AppContext);
	const {
		selectedUser: { zupeeUserId }
	} = useContext(UserDetailsContext);
	const { permissionsConfig } = useContext(UserContext);
	const getOpponentsGameDetails = useCallback(async (props: ITournamentDetails) => {
		const { gameName, tableId, registeredOnInMS, tournamentStartTimeInMS, tournamentEndTimeInMS, ltid } = props;
		const { appName } = app;
		const starttime: number = gameName === GAME_NAME_OPTIONS[GAME_NAMES.LUDONX] ? registeredOnInMS : tournamentStartTimeInMS;
		const endtime: number =
			gameName === GAME_NAME_OPTIONS[GAME_NAMES.LUDONX] ? getNxEndTime(registeredOnInMS) : tournamentEndTimeInMS;
		const date: string = moment(starttime).format('YYYY-MM-DD');
		const permission = _find(permissionsConfig, { actionName: ACTION.getOpponentsGameDetails });
		const result = await postData({
			endpoint: `/dashboard/getOpponentsGameDetails/${PAGE_NAMES.userProfile}-${USER_PROFILE_RESOURCES.gameplay}-getOpponentsGameDetails`,
			queryParams: {
				appName
			},
			body: {
				ludotournamentid: ltid,
				gamename: gameName,
				date,
				playingtableid: tableId,
				starttime,
				endtime
			},
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});

		const formattedData = formatData(
			result.data.data,
			{
				ltid,
				playingtableid: tableId,
				gamename: gameName
			},
			zupeeUserId
		);
		const listData = formatListData(formattedData);

		return { rowCount: listData.length, data: listData };
	}, []);

	return { getOpponentsGameDetails };
};

export default useService;
